import { zergApi } from "@/service/zerg";
import axios from "axios";

class UsersService {

    async forceChangePassword(params) {
        try {
            const data = await zergApi.post("/user/force-change-password", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getLasUserId(params) {
        try {
            const data = await zergApi.post("/user/get_user_last_id", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getNewsUsersOldSoft(params) {
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded' // Aquí puedes cambiar el tipo de contenido
                }
            };
            const data = await axios.post('https://old.rosymarperu.in/server/public/index.php/cronjob/tareo/get_news_users', params, config)
            return data;
        } catch (error) {
            throw error;
        }
    }

    async insertNewsUsersOfOldSot(params) {
        try {
            const data = await zergApi.post('user/insert-news-users', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getUsersSession(params) {
        try {
            const data = await zergApi.post('user/get-users-session', params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new UsersService();
